import { render, staticRenderFns } from "./PaymentSection.vue?vue&type=template&id=2045e5f8"
import script from "./PaymentSection.vue?vue&type=script&lang=js"
export * from "./PaymentSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports